import { appShellIcons, type AppShellIconKey } from "./appShellIcons";
export function AppShellIcon({ name }: { name?: AppShellIconKey | null }) { if (!name) return null; const Icon = appShellIcons[name]; return <Icon />; }
